.d3{border-radius:0.625rem;}